/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CountriesCoordinatesParams,
  CountryCoordinatesResponseDto,
  StandardHttpErrorDto,
} from '.././model';

import { apiInstance } from '../../whisApi.instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const Countries_coordinates = (
  params: CountriesCoordinatesParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<CountryCoordinatesResponseDto>(
    { url: `/api/countries/coordinates`, method: 'GET', params, signal },
    options,
  );
};

export const getCountriesCoordinatesQueryKey = (
  params?: CountriesCoordinatesParams,
) => {
  return [
    'api',
    'countries',
    'coordinates',
    ...(params ? [params] : []),
  ] as const;
};

export const getCountriesCoordinatesQueryOptions = <
  TData = Awaited<ReturnType<typeof Countries_coordinates>>,
  TError = StandardHttpErrorDto,
>(
  params: CountriesCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Countries_coordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCountriesCoordinatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof Countries_coordinates>>
  > = ({ signal }) => Countries_coordinates(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof Countries_coordinates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountriesCoordinatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof Countries_coordinates>>
>;
export type CountriesCoordinatesQueryError = StandardHttpErrorDto;

export function useCountriesCoordinates<
  TData = Awaited<ReturnType<typeof Countries_coordinates>>,
  TError = StandardHttpErrorDto,
>(
  params: CountriesCoordinatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Countries_coordinates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Countries_coordinates>>,
          TError,
          Awaited<ReturnType<typeof Countries_coordinates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountriesCoordinates<
  TData = Awaited<ReturnType<typeof Countries_coordinates>>,
  TError = StandardHttpErrorDto,
>(
  params: CountriesCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Countries_coordinates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Countries_coordinates>>,
          TError,
          Awaited<ReturnType<typeof Countries_coordinates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountriesCoordinates<
  TData = Awaited<ReturnType<typeof Countries_coordinates>>,
  TError = StandardHttpErrorDto,
>(
  params: CountriesCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Countries_coordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useCountriesCoordinates<
  TData = Awaited<ReturnType<typeof Countries_coordinates>>,
  TError = StandardHttpErrorDto,
>(
  params: CountriesCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Countries_coordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCountriesCoordinatesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
